SupportMainContentWrapperView = require('../../main_content_view')
StepTwoBaseView = require('../base_view')

class StepTwoInbentaBaseView extends StepTwoBaseView

  initialize: (options)->
    @options = options || {}
    StepTwoBaseView::initialize.apply(this, arguments)
    @isInbentaContentShown = false
    @dropDownCombinationsModel = @options.dropDownCombinationsModel
    if @dropDownCombinationsModel.has('flexStepThree')
      @dropdownCombinations = @dropDownCombinationsModel.attributes
    @flexStepThree =
      allowed: false
      responseReceived: false
      dropdownCombinations: @dropdownCombinations

  resetFlexStepThree : () ->
    @flexStepThree.allowed = false
    @flexStepThree.responseReceived =  false

  render: ->
    Groupon.Support.ContentModel.onInitStepTwo()
    @fetchFlexibleContactChannels()
    @hideComponents()
    toggleCallUs(Groupon.Support.CURRENTVIEW.id)
    mainContentWrappper = new SupportMainContentWrapperView
    mainContentWrappper.render( (contentWrapper) =>
      @renderProgressBar(contentWrapper)
      @renderOrderInfo(contentWrapper)
      @fetchAndRenderCategory(contentWrapper)
      @renderInbentaSearchBox(contentWrapper)
    )
    @$el.append(mainContentWrappper.el)
    @renderStepTwoActions()
    @renderLiveChat(@$el)

  isFlexStepThreeAllowed: ->
    taglineSelected = "#{@getCategoryId()},#{@getSubCategoryId()}"
    @flexStepThree['allowed'] = experiments?.flexStepThreeForUS and _.indexOf(@dropDownCombinationsModel.get('flexStepThree'), taglineSelected) isnt -1
    @flexStepThree['allowed']

  getHelpContentSuccessCb: () =>
    @helpContentSuccess

  getHelpContenteErrorCb: () =>
    @helpContentError

  isCategoryAndSubcategorySelected: ()->
    Groupon.Support.ContentModel.getCategory()? and Groupon.Support.ContentModel.getSubCategory()?

  getHelpContentPaths: ->
    url = "#{window.SUPPORTBASEURL}/fetch"
    urls = [url]

  getTaglines: ->
    base = "#{@getCategoryId()},#{@getSubCategoryId()}"
    return [{ key: base, base: "helpwizard_email_form", type:"flexible_step_three" }]

  fetchFlexibleContactChannels: ()->
    if @shouldFetchFlexibleContactChannels()
      @flexibleContactChannelModel.setFetchContactChannelFromCMS()
      @flexibleContactChannelModel.fetch()

module.exports = StepTwoInbentaBaseView
